<template>
  <div :class="classes.container">
    <div :class="classes.wrapper">
      <CardHeader :eventId="eventId" />
      <EventName
        :class="[classes.eventName, 'event-name']"
        :eventId="eventId"
      />

      <MarketTags :tags="tags" />

      <div :class="classes.options">
        <Button
          :stagger="0"
          :class="classes.button"
          :optionId="homeAwayOptions[0].options[0]"
          :marketId="homeAwayOptions[0].marketId"
        />

        <Button
          :stagger="1"
          :class="classes.button"
          :optionId="homeAwayOptions[0].options[1]"
          :marketId="homeAwayOptions[0].marketId"
          :isDraw="true"
        />

        <Button
          :stagger="2"
          :class="classes.button"
          :optionId="homeAwayOptions[0].options[2]"
          :marketId="homeAwayOptions[0].marketId"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { ComputedRef, defineComponent, ref } from "vue";
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";

import EventName from "../../../EventNamesBadgesVertical.vue";
import CardHeader from "../../../CardHeader.vue";
import MarketTags from "../../../MarketTags.vue";
import Button from "../Button.vue";

import {
  composeHomeAwayOptions,
  composeMarket
} from "@fresh8/ad-data-composition/src/betData";
import { Market } from "@fresh8/types/src/betData";

const useStyles = createUseStyles({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column"
  },
  market: {
    padding: "0"
  },
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
    border: props => `1px solid ${props.marketBorderColor || "#dcddf"}`,
    background: props => props.cardBackgroundColor,
    borderRadius: props => `${props.borderRadius}px`,

    "& .tags": {
      paddingBottom: "12px"
    }
  },
  eventMarketWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "8px",
    boxSizing: "border-box"
  },
  options: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    padding: "0 8px"
  },
  button: {
    flex: 1,

    marginBottom: "10px",
    "&:last-of-type": {
      marginBottom: "12px"
    }
  },
  eventName: {
    borderBottom: props => `1px solid ${props.marketBorderColor || "#dcddf"}`
  }
});

export default defineComponent({
  name: "LargeMPUWDW",
  components: {
    CardHeader,
    EventName,
    Button,
    MarketTags
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const { adTemplateBranding, marketBranding } =
      injectBrand() || ({} as BrandContext);
    const marketId = ref([props.marketId]);
    const marketData = composeMarket(props.marketId) as ComputedRef<Market>;
    const classesRef = useStyles(adTemplateBranding);
    const homeAwayOptions = composeHomeAwayOptions(marketId);

    return {
      marketBranding,
      classes: classesRef,
      homeAwayOptions,
      tags: [marketData.value.marketName]
    };
  }
});
</script>
